// RoseKin Shared Accordion — animated open/close + single/multi-open
// Opt-in via containers with [data-rk="accordion"].

function rkAnimateOpen(details) {
	const content = details.querySelector('.rk-acc-content');
	if (!content) return;
	details.dataset.animating = 'open';
	content.style.height = '0px';
	content.style.overflow = 'hidden';
	const endHeight = content.scrollHeight;
	requestAnimationFrame(() => {
		content.style.height = endHeight + 'px';
	});
	const onEnd = (ev) => {
		if (ev.propertyName !== 'height') return;
		content.removeEventListener('transitionend', onEnd);
		content.style.height = '';
		content.style.overflow = '';
		delete details.dataset.animating;
	};
	content.addEventListener('transitionend', onEnd);
}

function rkAnimateClose(details) {
	if (!details.open) return;
	const content = details.querySelector('.rk-acc-content');
	if (!content) { details.open = false; return; }
	details.dataset.animating = 'close';
	const startHeight = content.scrollHeight;
	content.style.height = startHeight + 'px';
	content.style.overflow = 'hidden';
	requestAnimationFrame(() => {
		content.style.height = '0px';
	});
	const onEnd = (ev) => {
		if (ev.propertyName !== 'height') return;
		content.removeEventListener('transitionend', onEnd);
		details.open = false;
		content.style.height = '';
		content.style.overflow = '';
		delete details.dataset.animating;
	};
	content.addEventListener('transitionend', onEnd);
}

function rkSetupAccordion(container) {
	if (container.dataset.rkAccordionBound === 'true') return;
	container.dataset.rkAccordionBound = 'true';

	const singleOpen = container.dataset.singleOpen !== 'false'; // default true

	container.addEventListener('click', (event) => {
		const summary = event.target.closest && event.target.closest('summary.rk-acc-summary');
		if (!summary || !container.contains(summary)) return;
		const details = summary.parentElement;
		if (!(details instanceof HTMLDetailsElement)) return;

		event.preventDefault();
		if (details.dataset.animating) return;

		if (details.open) {
			rkAnimateClose(details);
		} else {
			if (singleOpen) {
				container.querySelectorAll('.rk-acc-item[open]').forEach((el) => {
					if (el !== details && !el.dataset.animating) rkAnimateClose(el);
				});
			}
			details.open = true;
			rkAnimateOpen(details);
		}
	});
}

function rkInitAccordions() {
	document.querySelectorAll('[data-rk="accordion"]').forEach(rkSetupAccordion);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', rkInitAccordions, { once: true });
} else {
	rkInitAccordions();
}

document.addEventListener('shopify:section:load', (e) => {
	e.target.querySelectorAll('[data-rk="accordion"]').forEach(rkSetupAccordion);
});

